const getPickUnit = (productBasketTypeCode?: string) => {
  return (productBasketTypeCode || '').toLowerCase() === 'st' ? 'pieces' : 'kilogram';
};

export default getPickUnit;
